// extracted by mini-css-extract-plugin
export default {"loaderFullPageWrapper":"Loader_loaderFullPageWrapper__m7gWY","loaderWrapper":"Loader_loaderWrapper__AJ5kY","loader":"Loader_loader__gqavW","spinner":"Loader_spinner__h19Cs"};